import { MessageBox } from "./../components/MessageBox";
import { IUserMessage } from "../models";

/**
 * IMPORTANT: Note for enhancements
 * --------------------------------
 * Default implementation suppresses errors which cannot be handled by JIT-UX Apps and chances that multiple JIT-UX Apps raise that error is high. E.g.,
 * errors raised by third party libraries, or window object, for which there is no way that JIT-UX App can handle that error.
 *
 * If we get requirement for suppressing JIT-UX App specific error, we need to come with extensible design, that allows
 * JIT-UX App to intercept and control whether or not to show the message box.
 *
 * */

const suppressMessages = [/^ResizeObserver loop completed with undelivered notifications./i];

class MessageHandler {
  handle(message: IUserMessage) {
    if (suppressMessages.some(x => x.test(message.detail)))
      console.warn("[JIT-UX (Suppressed unhandled error)]", message.message, message.detail);
    else MessageBox.show(message);
  }
}

export const messageHandler = new MessageHandler();
